<template>
  <div>
    <mdb-row style="margin-bottom: -4rem;">
      <mdb-col md="3" class="card-div">
        <div class="title-style">
          CLUBES
          <br />
          <div style="font-size: 16px; font-weight: lighter;; display: -webkit-box;">
            Clubs registrados: &nbsp;<span style="font-size:18px; font-weight:600">{{ totalOfElements }}</span>
          </div>
        </div>
      </mdb-col>
      <mdb-col md="7" class="card-div searchBar">
        <input
          class="input-style"
          type="text"
          name="buscador"
          id="search"
          v-model="search"
          placeholder="Busca el club de tu elección por nombre o correo de administrador"
        />
      </mdb-col>
    </mdb-row>
    <mdb-row>
        <b-table :items="dataList" :fields="columns" class="text-center" :responsive="true" :no-provider-paging="true"
            :show-empty="true"
            emptyText="No se ha(n) encontrado resultado(s) de solicitudes que coincida(n) con tu búsqueda."
            emptyFilteredText="No se ha(n) encontrado resultado(s) de solicitudes que coincida(n) con tu búsqueda.">
            <template #cell(date)="data">
              01-01-2020
            </template>

            <template #cell(address)="data">
              <div v-if="data.item.address.location != null">
                {{data.item.address.location.city+', '+data.item.address.location.colony+', '+data.item.address.street+', #'+data.item.address.externalNumber}}
              </div>
              <div v-else class="text-center">SIN DIRECCION</div>
            </template>

            <template #cell(options)="data">
              <div>
              <button type="button" class="btn btn-edit" @click="editClubOpenModal(data.item)">
                <img :src="'/img/icons/InoEditarr.svg'" alt="icon editar" />
              </button>
              <button type="button" class="btn btn-delete" @click="eliminarClubOpenModal(data.item)">
                <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
              </button>
            </div>
            </template>
        </b-table>
    </mdb-row>

    <Paginator stylePaginator="full" :currentPage="page" :totalRows="totalOfElements" :perPage="perPage"
        @changePage="changePage" @changePerPage="changePerPage" />

    <!-- <mdb-row>
      <table class="t1-table text-center">
        <tr>
          <th>Fecha</th>
          <th>Nombre</th>
          <th>Código</th>
          <th>Dirección</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in displayedPost" v-bind:key="index">
          <td class="text-center">01-01-2020</td>
          <td class="text-center">{{item.clubName}}</td>
          <td class="text-center">{{item.clubCode}}</td>
          <td
            v-if="item.address.location != null"
            class="text-center"
          >{{item.address.location.city+', '+item.address.location.colony+', '+item.address.street+', #'+item.address.externalNumber}}</td>
          <td v-else class="text-center">{{'SIN DIRECCION'}}</td>

          <td class="text-center">
            <div>
              <button type="button" class="btn btn-edit" @click="editClubOpenModal(item)">
                <img :src="'/img/icons/InoEditarr.svg'" alt="icon editar" />
              </button>
              <button type="button" class="btn btn-delete" @click="eliminarClubOpenModal(item)">
                <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
              </button>
            </div>
          </td>
        </tr>
      </table>
    </mdb-row> -->
    <!-- <mdb-row>
      <mdb-col>
        <Btn
          type="primary-block2"
          icon="plus"
          text="AGREGAR NUEVO CLUB"
          class="btn-add"
          @onClick="closeModal"
        />
      </mdb-col>
      <mdb-col>
        <div class="selectdiv">
          <div>
            <nav style="position: absolute; right: 80%;">
              <ul class="t1-pagination">
                <li v-if="page != 1">
                  <a @click="page--">
                    <img
                      src="../../../../public/img/icons/IconFlechaAbajo.svg"
                      alt
                      style="transform: rotate(90deg)"
                    />
                  </a>
                </li>
                <li
                  :class="pageNumber==page? 't1-pagination--active':''"
                  v-for="pageNumber in pages.slice(page-1, page+3)"
                  :key="pageNumber"
                >
                  <a @click="page = pageNumber">{{pageNumber}}</a>
                </li>
                <li v-if="page < pages.length" @click="page++">
                  <a>
                    <img
                      src="../../../../public/img/icons/IconFlechaAbajo.svg"
                      alt
                      style="transform: rotate(270deg)"
                    />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div>
            <select name="pages" id="pages">
              <option value="1">Pag. 1</option>
              <option value="2">Pag. 2</option>
              <option value="3">Pag. 3</option>
            </select>
          </div>
        </div>
      </mdb-col>
    </mdb-row> -->
    <Popup size="sm" title header ref="deleteClub" style="max-width: 500px;">
      <div class="text-left">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div
                style="font-family: Josefin Sans;
                  font-size: 22px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  color: #dc7134;
                  margin-left: 25%;
                  margin-right: 25%;"
              >¿ELIMINAR CLUB?</div>
            </mdb-row>
            <mdb-row class="mt-5">
              <div
                style="font-family: Open Sans;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f4f4f"
              >El registro de club será eliminado del sistema de forma permanente.</div>
            </mdb-row>
            <mdb-row style="margin-top: 5rem;">
              <div class="divLine"></div>
            </mdb-row>
            <mdb-row class="mt-3">
              <div style="margin-left: 20%;">
                <Btn
                  @onClick="eliminarClub"
                  :text="'Eliminar'"
                  :type="'primary-admin'"
                  style="float:right;"
                ></Btn>
                <Btn
                  @onClick="$refs.deleteClub.toggleModal()"
                  :text="'Cancelar'"
                  :type="'primary-admin-ghost'"
                  style="float:right; margin-right: 1rem;"
                ></Btn>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>
    <Popup size="md" :title="titlePop" :header="classPop" classTitle="popup__title-mod" ref="club">
      <mdb-col>
        <mdb-row class="mt-3">
          <span class="modal-admin-title">Ingresa los datos del club que deseas registrar:</span>
        </mdb-row>
        <mdb-row class="mt-5">
          <div v-if="fileAvatar==''" class="image-upload">
            <label for="image-release">
              <img
                :src="'/img/icons/upload-logo.svg'"
                class="icon"
                alt="agregar foto"
                style="cursor: pointer;"
              />
            </label>
            <input
              type="file"
              accept="image/jpg, image/png"
              name="file"
              id="image-release"
              style="display: none;"
              @change="uploadFile"
            />
          </div>
          <div v-else class="image-upload input-group">
            <img :src="fileAvatar" class="avatar-pic" alt="Profile Picture" />
            <img
              :src="'/img/icons/editar-foto.svg'"
              class="edit-pic"
              alt="Profile Picture"
              style="cursor: pointer;"
            />
          </div>
        </mdb-row>
        <mdb-row class="mt-3">
          <mdb-col md="6">
            <label
              for="name"
              class="labelPop"
              style="font-size: 1.3rem !important;"
            >Nombre del club:</label>
            <input type="text" class="form__input" id="name" required v-model="clubName" />
            <validation-error :validation="$v.clubName"></validation-error>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-3">
          <mdb-col md="4">
            <label for="cp" class="labelPop" style="font-size: 1.3rem !important;">C.P.:</label>
            <input
              type="text"
              class="form__input"
              id="cp"
              required
              v-model="codePostal"
              v-mask="'#####'"
              @change="getLocations"
            />
            <validation-error :validation="$v.codePostal"></validation-error>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-3">
          <mdb-col md="6">
            <label for="city" class="labelPop" style="font-size: 1.3rem !important;">Ciudad:</label>
            <input type="text" class="form__input" id="city" required v-model="city" disabled />
            <validation-error :validation="$v.city"></validation-error>
          </mdb-col>
          <mdb-col md="6">
            <label for="state" class="labelPop" style="font-size: 1.3rem !important;">Estado:</label>
            <input type="text" class="form__input" id="state" required disabled v-model="state" />
            <validation-error :validation="$v.state"></validation-error>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-3">
          <mdb-col md="6">
            <label for="colony" class="labelPop" style="font-size: 1.3rem !important;">Colonia:</label>
            <v-select
              label="colony"
              id="colony"
              class="form__input"
              :options="listColony"
              v-model="colony"
            ></v-select>
            <validation-error :validation="$v.colony"></validation-error>
          </mdb-col>
          <mdb-col md="6">
            <label for="street" class="labelPop" style="font-size: 1.3rem !important;">Calle:</label>
            <input type="text" class="form__input" id="street" required v-model="street" />
            <validation-error :validation="$v.street"></validation-error>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-3">
          <mdb-col md="6">
            <label for="admin" class="labelPop" style="font-size: 1.3rem !important;">Administrador:</label>
            <v-select
              label="email"
              id="admin"
              class="form__input"
              :options="listAdmins"
              v-model="adminSelect"
            ></v-select>
            <validation-error :validation="$v.adminSelect"></validation-error>
          </mdb-col>
          <mdb-col md="3">
            <label for="number" class="labelPop" style="font-size: 1.3rem !important;">Número:</label>
            <input type="text" class="form__input" id="number" required v-model="number" />
            <validation-error :validation="$v.number"></validation-error>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-3">
          <mdb-col md="3"></mdb-col>
          <mdb-col v-if="isEdit" md="8">
            <Btn
              @onClick="registerClub"
              :text="'Guardar cambios'"
              :type="'primary-admin'"
              style="float:right;"
            ></Btn>
            <Btn
              @onClick="closeModal"
              :text="'Cancelar'"
              :type="'primary-admin-ghost'"
              style="float:right;"
            ></Btn>
          </mdb-col>
          <mdb-col v-else md="6">
            <Btn
              @onClick="registerClub"
              :text="'Registrar Club'"
              :type="'primary-admin'"
              style="float:right;"
            ></Btn>
          </mdb-col>
        </mdb-row>
      </mdb-col>
    </Popup>
  </div>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Btn from "../../core/Button";
import Popup from "../../core/Popup";
import Swal from "sweetalert2";
import {
  required,
  requiredIf,
  email,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import ValidationError from "../misc/ValidationError";
import Paginator from "../../core/Paginator.vue"
export default {
  name: "Clubs",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    Btn,
    Popup,
    "v-select": vSelect,
    ValidationError,
    Paginator
  },
  directives: { mask },
  data() {
    return {
      totalOfElements: 0,
      page: 1,
      perPage: 10,
      pages: [],
      numberOfPages: 0,
      search: "",
      dataList: [],
      titlePop: "Agregar nuevo club",
      classPop: "popup__header-admin",
      isEdit: false,
      fileAvatar: "",
      filesProfile: null,
      clubName: "",
      uuidClub: "",
      codePostal: "",
      state: "",
      city: "",
      street: "",
      colony: "",
      number: "",
      listColony: [],
      listAdmins: [],
      adminSelect: "",
      clubCode: "",
      columns: [
                {
                    label: 'Fecha',
                    key: 'date',
                    sort: false,
                    class: 'text-center',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff",
                        "border-top-left-radius": "5px",
                        "border-bottom-left-radius": "5px"
                    },
                    tdClass: "tableCol-start",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Nombre',
                    key: 'clubName',
                    sort: false,
                    class: 'text-center',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Código',
                    key: 'clubCode',
                    sort: false,
                    class: 'text-center',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: 'Dirección',
                    key: 'address',
                    sort: false,
                    class: 'text-center',
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 0.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
                {
                    label: '', 
                    key: 'options', 
                    sort: false, 
                    class: 'text-center', 
                    thStyle: {
                        "font-size": "1.6rem",
                        "padding": "1.0rem 2.5rem",
                        "background-color": "#3a8a65",
                        "color": "#fff"
                    },
                    tdClass: "tableCol",
                    tdStyle: {
                        "font-size": "1.6rem",
                    }
                },
            ],
    };
  },
  validations: {
    clubName: { required },
    codePostal: { required },
    state: { required },
    city: { required },
    colony: { required },
    street: { required },
    number: { required },
    adminSelect: { required },
  },
  methods: {
    ...mapActions([
      "getListOfClubs",
      "getListOfAdmins",
      "updateClub",
      "obtainLocations",
      "getListOfUsersUnssigned",
      "getListOfAdministrators",
      "deleteClub",
      "postClub",
    ]),
    async getLocations() {
      if (this.codePostal.length == 5) {
        let response = await this.obtainLocations(this.codePostal);

        if (response.data) {
          this.listColony = response.data.data;
          this.state = response.data.data[0].state;
          this.city = response.data.data[0].city;
        }
      }
    },
    async registerClub() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.isEdit) {
          let body = {
            data: {
              clubName: this.clubName,
              adminId: this.adminSelect.id,
              // partnerRecommendationsNumber: 4,
              // committeeVotes: 3,
            },
            uuid: this.uuidClub,
          };
          //console.log(this.colony.id);
          if (this.colony.id != null) {
            var addressDTO = {
              street: this.street,
              externalNumber: this.number,
              locationId: this.colony.id,
            };
            body.data.addressDTO = addressDTO;
          }

          if (this.filesProfile != null) {
            var logo = {
              documentType: "LOGO",
              value: "Logotipo Club",
              extension: "jpeg",
              mimeType: "image/jpeg",
              content: this.filesProfile,
            };
            body.data.logoDTO = logo;
          }

          //console.log(body);
          let response = await this.updateClub(body);
          //console.log(response.data);

          if (response.data.status == 200) {
            this.registerEditDone();
          }
        } else {
          let body = {
            clubName: this.clubName,
            adminId: this.adminSelect.id,
            // partnerRecommendationsNumber: 4,
            // committeeVotes: 3,
            addressDTO: {
              street: this.street,
              externalNumber: this.number,
              locationId: this.colony.id,
            },
            logoDTO: {
              documentType: "LOGO",
              value: "Logotipo Club",
              extension: "jpeg",
              mimeType: "image/jpeg",
              content: this.filesProfile,
            },
          };
          //console.log(body);
          let response = await this.postClub(body);
          //console.log(response.data);

          if (response.data.status == 200) {
            this.registerDone();
          }

        }
        this.closeModal();
      }
    },
    closeModal() {
      this.isEdit = false;
      this.titlePop = "Agregar nuevo club";
      this.classPop = "popup__header-admin";
      this.clubName = "";
      this.fileAvatar = "";
      this.uuidClub = "";
      this.$refs.club.toggleModal();
    },
    async editClubOpenModal(item) {
      //console.log(item);

      this.isEdit = true;
      this.titlePop = "Editar club";
      this.classPop = "popup__header-edit";
      this.clubName = item.clubName;
      this.uuidClub = item.clubCode;
      if (item.address.location != null) {
        this.codePostal = item.address.location.zipCode;
        //this.colony=item.address.location.colony
        this.state = item.address.location.state;
        this.city = item.address.location.city;
        this.street = item.address.street;
        this.number = item.address.externalNumber;
        await this.getLocations();
        var aux = this.listColony.filter(function (col) {
          return col.colony == item.address.location.colony;
        });

        this.colony = aux[0];
      }

      //this.adminSelect = item.users[0].username
      //item.logo == null ? (this.fileAvatar = "") : (this.fileAvatar = logo);
      this.$refs.club.toggleModal();
    },
    eliminarClubOpenModal(item){
      this.clubCode = item.clubCode;
      this.$refs.deleteClub.toggleModal()

    },
    cleanDataTable() {
      this.totalOfElements = 0;
      this.page = 1;
      this.perPage = 10;
      this.pages = [];
      this.numberOfPages = 0;
      this.search = "";
      this.dataList = [];
      this.clubCode = ""
    },
    async getDataClubs() {
      let params = {};
      params.clubCode = "CGTM";
      params.pageNumber = 0;
      params.pageSize = 15;
      this.listAdmins = [];
      let response = await this.getListOfAdministrators(params);
      this.listAdmins = response.data.data;

      response = await this.getListOfUsersUnssigned();
      if (response.data.data != null) {
        this.listAdmins = this.dataList.concat(response.data.data);
      }

      //console.log(this.listAdmins)

      // let response = await this.getListOfAdmins();
      // this.listAdmins  = response.data.data;

      response = await this.getListOfClubs();
      if (response.data.data != null) {
        this.dataList = response.data.data;
        this.totalOfElements = this.dataList.length;
      } else {
        this.dataList = [];
        this.totalOfElements = 0;
      }
    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / this.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    uploadFile: function (evt) {
      this.fileAvatar = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesProfile = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    // setAdmin(value) {
    //   this.$store.commit("setAdminSelected", value);
    // },
    registerDone() {
      Swal.fire({
        title:
          " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>REGISTRO CORRECTO</span>",
        html:
          "<div>" +
          "<p class='mt-2'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'> Registro de club confirmado y creado correctamente.</p>" +
          "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
          "</div>",
        width: "50rem",
        padding: "2rem",
        showConfirmButton: false,
        showCloseButton: true,
        onClose: () => {
          this.cleanDataTable();
         this.getDataClubs();
        }
      })
    },
    registerEditDone() {
      Swal.fire({
        title:
          " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>CAMBIOS GUARDADOS CORRECTAMENTE</span>",
        html:
          "<div>" +
          "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
          "</div>",
        width: "50rem",
        padding: "4rem",
        showConfirmButton: false,
        showCloseButton: true,
        onClose: () => {
          this.cleanDataTable();
         this.getDataClubs();
        }
      });
    },
    errorMessage() {
      Swal.fire({
        title:
          "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
        html:
          "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
          "<p>No ha sido posible registrar el club.</p>" +
          "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
          "</div>",
        allowOutsideClick: false,
        width: "50rem",
        padding: "2rem",
        confirmButtonText: "Ok",
        confirmButtonColor: "#dc7134",
        customClass: {
          confirmButton: "t1-btn t1-btn--primary-block",
        },
        onClose: () => {
          this.cleanDataTable();
         this.getDataClubs();
        }
      }).then((result) => {});
    },
    async eliminarClub() {
      try {
        let response = await this.deleteClub(this.clubCode);

        if (response.data.status == 200) {
          Swal.fire({
        title:
          " <span style='font-family: Josefin Sans; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>ELIMINACION CORRECTA</span>",
        html:
          "<div>" +
          "<p class='mt-2'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'> El club ah sido eliminado correctamente.</p>" +
          "<img src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
          "</div>",
        width: "50rem",
        padding: "2rem",
        showConfirmButton: false,
        showCloseButton: true,
        onClose: () => {
          this.$refs.deleteClub.toggleModal()
          this.cleanDataTable();
         this.getDataClubs();
        }
        });
      }
      } catch (error) {
        let emessage = "";
        if (error.response.data.message) {
          emessage = error.response.data.message;
        }
        this.$notify.error({
          message: emessage,
          position: "top right",
          timeOut: 15000,
        });
      }
    },
    changePage(value) {
      this.page = value
    },
    changePerPage(value) {
      this.perPage = value
    },
  },
  mounted() {
    this.cleanDataTable();
    this.getDataClubs();
  },
  created() {},
  computed: {
    // ...mapGetters({
    //   listAdmins: "getAdmins",
    //   adminSelect: "getAdminSelected"
    // }),
    displayedPost() {
      return this.paginate(this.dataList);
    },
  },
  watch:{
    codePostal(val){
      if(val.length == 5){
        this.getLocations()
      }
    },
    page() {
      this.getDataClubs();
    },
    perPage() {
      this.getDataClubs();
    },
  }
};
</script>

<style scoped >
.modal-admin-title {
  font-family: Open Sans;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f4f4f;
}

.image-upload > input {
  display: none;
}
.edit-pic {
  cursor: pointer;
  position: absolute;
  z-index: 100;
}
.avatar-pic {
  border-radius: 50%;
  width: 13rem;
  height: 13rem;
}
</style>

<style >
.vs__dropdown-toggle {
  border: 0;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f4f4f;
}

.divLine {
  width: 100%;
  border: 0.1rem solid #828282;
}


.tableCol {
    background-color: #fff;
    color: #000;
    font-size: 1.6rem;
}

.tableCol-start {
    background-color: #fff;
    color: #000;
    font-size: 1.6rem;
}

.tableCol-end {
    background-color: #fff;
    color: #000;
    font-size: 1.6rem;
}

@media (min-width: 1024px) and (max-width: 1449px) {

    .table td {
        padding: 0.25rem;
    }

    .tableCol-start {
        padding-left: 30px !important;
        padding-right: 10px !important;
    }


    table.table-status {
        width: 100%;
    }

    table.table-status th {
        color: #dc7134;
        font-size: 1.8em;
    }

    table.table-status td {
        font-size: 1.6em;
    }
}
</style>